import { useAuth } from '@platform/auth-client';
import { FINANCE_READ_ROLE } from '../finance/finance.ts';
import { DashboardHeader } from './DashboardHeader.tsx';
import { useWidgetContext, type DashboardProps } from './dashboard-props.ts';
import { DashboardGrid } from './widgets/DashboardGrid.tsx';
import { DEFAULT_LAYOUT } from './widgets/default-layout.ts';

export const FixedDashboard = (props: DashboardProps) => {
  const financeVisible = useAuth().hasRole(FINANCE_READ_ROLE);
  const context = useWidgetContext(props);
  return (
    <>
      <DashboardHeader {...props} range={context.range} />
      <DashboardGrid layout={DEFAULT_LAYOUT} context={context} financeVisible={financeVisible} />
    </>
  );
};
